import React from 'react';
import './productQuantitySteppers.scss';
export class Quantity extends React.Component {
  quantityBlur = (e) => {
    const value = e.target.getAttribute('value');
    if (value == '') {
      if (this.props.isProductItem) {
        this.props.forceItemQuantity(e);
      } else {
        this.props.forceQuantity();
      }
    }
  };
  render() {
    return (
      <div className='qty-wrapper'>
        <div className='m-b-5'>
          <label
            id={
              this.props.multipleProds
                ? 'Quantity for ' + this.props.contentData.itemInfo[this.props.prodIndex].sku
                : 'Quantity__' + this.props.contentData.partNumber
            }
            htmlFor={
              this.props.multipleProds
                ? 'Quantity for ' + this.props.contentData.itemInfo[this.props.prodIndex].sku
                : 'Quantity__' + this.props.contentData.partNumber
            }
            className='label d-inline'
          >
            Quantity
          </label>
        </div>
        <div className='quantityInputWrapper'>
          {
            <span
              className='stepperQtyMinus'
              data-value={isNaN(parseInt(this.props.quantity, 10)) ? '0' : this.props.quantity * 1 - 1}
              data-minimum={this.props.minimumQuantity ? this.props.minimumQuantity : 1}
              data-maximum={this.props.maximumQuantity ? this.props.maximumQuantity : 99}
              onClick={this.props.updateQuantity}
              role='button'
              aria-label='Subtract 1 item'
              tabIndex='0'
            >
              -
            </span>
          }
          <input
            id={
              this.props.multipleProds
                ? 'Quantity for ' + this.props.contentData.itemInfo[this.props.prodIndex].sku
                : 'Quantity__' + this.props.contentData.partNumber
            }
            onChange={this.props.updateQuantity}
            onBlur={this.quantityBlur}
            name='quantity'
            className={`inputQuantity form-control ${this.props.className ? this.props.className : ''}`}
            type='tel'
            maxLength='2'
            value={isNaN(parseInt(this.props.quantity, 10)) ? '' : parseInt(this.props.quantity, 10)}
            data-minimum={this.props.minimumQuantity ? this.props.minimumQuantity : 1}
            data-maximum={this.props.maximumQuantity ? this.props.maximumQuantity : 99}
            aria-labelledby={
              this.props.multipleProds
                ? 'Quantity for ' + this.props.contentData.itemInfo[this.props.prodIndex].sku
                : 'Quantity__' + this.props.contentData.partNumber
            }
          />
          {
            <span
              className='stepperQtyPlus'
              data-value={isNaN(parseInt(this.props.quantity, 10)) ? '2' : this.props.quantity * 1 + 1}
              data-minimum={this.props.minimumQuantity ? this.props.minimumQuantity : 1}
              data-maximum={this.props.maximumQuantity ? this.props.maximumQuantity : 99}
              onClick={this.props.updateQuantity}
              role='button'
              aria-label='Add 1 item'
              tabIndex='0'
            >
              +
            </span>
          }
        </div>
      </div>
    );
  }
}

export default Quantity;
